// ABOUTME: Custom progress bar component with label and plan/fact values display
// ABOUTME: Shows progress percentage with color-coded indicator

import * as React from "react"
import { memo, useMemo } from "react"
import { cn } from "@shared/lib/utils"

interface IProps {
  label: string
  value: { progress: number | undefined; planVal: string | undefined; factVal: string | undefined; color?: string }
  size?: "sm" | "md" | "lg"
  type?: string
}

const sizeClasses = {
  sm: "h-[3px]",
  md: "h-2",
  lg: "h-4",
}

const colorClasses = {
  green: "bg-green-500",
  blue: "bg-blue-500",
  purple: "bg-purple-500",
  yellow: "bg-yellow-500",
}

const bgColorClasses = {
  green: "bg-green-300",
  blue: "bg-blue-300",
  purple: "bg-purple-300",
  yellow: "bg-yellow-300",
}

export const CProgressBar = memo((props: IProps) => {
  const { label, value, size = "sm", type = "minutes" } = props

  const getRandomInt = (max: number) => {
    return Math.floor(Math.random() * max)
  }

  const getRandomColor = useMemo(() => {
    switch (getRandomInt(4)) {
      case 0:
        return "green"
      case 1:
        return "blue"
      case 2:
        return "purple"
      case 3:
        return "yellow"
      default:
        return "green"
    }
  }, [])

  const isOverPlan = Number(value.factVal || 0) > Number(value.planVal || 0)

  return (
    <div className="relative mb-2.5 w-full">
      <div className="mb-1">
        <div className="text-[10px] font-bold text-[#373737] dark:text-gray-700 mb-1">
          {label} <span className="font-normal text-[#B3B3B3]">{type}</span>
        </div>
        <div className="flex justify-between text-[9px] font-bold text-black">
          {value.factVal} <span>{value.planVal}</span>
        </div>
      </div>
      <div
        className={cn(
          "relative w-full overflow-hidden rounded-full",
          sizeClasses[size],
          isOverPlan ? bgColorClasses[getRandomColor] : "bg-gray-200",
        )}
      >
        <div
          className={cn("h-full transition-all", colorClasses[getRandomColor])}
          style={{ width: `${Math.min(value.progress || 0, 100)}%` }}
        />
      </div>
    </div>
  )
})

CProgressBar.displayName = "CProgressBar"
